import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {  getToolList } from "../../Thunks/HeyTraderThunks";
import { ToolListData } from "../../Types/HeyTraderTypes/Tools/ToolListData";

interface ToolSliceState {
    loader: boolean; // for refres pages and inital loadings
    toolList: ToolListData[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ToolSliceState = {
    loader: false,
    toolList: [],
    errorDisplay: '',

}

// set state valu for api response

const toolListSlice = createSlice ({
    name: 'toolList',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getToolList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getToolList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getToolList.fulfilled, (state, action: PayloadAction<ToolListData[]>) => {
                    state.loader = false;
                    state.toolList = action.payload;
                  })
    }
})

export const {} = toolListSlice.actions
export default toolListSlice.reducer

